import { Skeleton } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

type ContainerProps = {
    $isMobileHidden?: boolean;
};

export const MapContainer = styled.div<ContainerProps>`
    height: 18.75rem;
    border-radius: 0.5rem;
    overflow: hidden;
    display: ${({ $isMobileHidden }) => ($isMobileHidden ? 'none' : 'block')};
    margin-top: ${getPurpurSpacing('300')};
    margin-bottom: ${getPurpurSpacing('300')};

    ${purpurMedia('xl')`
        display: block;
        height: 40.625rem;
        width: 50.9rem;
        margin: 0;
    `};
`;

export const MapSkeleton = styled(Skeleton)`
    width: 100%;
    height: 100%;
`;
